<template>
  <div v-if="bufferTagList.length" class="molecule_container">
    <div v-if="isEditable" class="custom__margin-top">Tag</div>
    <div
      v-if="!isTagEditMode"
      class="tag-badge--space"
      :class="{ 'badge--no-margin-left': !isEditable }"
    >
      <b-badge
        v-for="(tag, index) in bufferTagList"
        :key="index"
        variant="light-primary"
        class="tag--space"
      >
        {{ tag }}
      </b-badge>
      <b-badge
        v-if="isEditable"
        variant="primary"
        class="tag--space button__edit-tag"
        @click="editTagToggle"
      >
        <feather-icon icon="Edit2Icon" />
      </b-badge>
    </div>
    <atom-multi-select
      v-if="isTagEditMode"
      v-model="bufferTagList"
      :option="optionTagList"
      :isSmall="true"
      :isPushTaggable="true"
      :isEnableProper="false"
      :isAppendToBody="false"
      class="multi-select--space"
    ></atom-multi-select>
    <div
      v-if="isTagEditMode"
      class="custom__margin-top custom__icon"
      @click="confirmEditTag"
    >
      <feather-icon
        icon="SaveIcon"
        stroke="#B9B9C3"
        class="custom__icon--size"
      />
    </div>
    <div
      v-if="isTagEditMode"
      class="custom__margin-top custom__icon"
      @click="cancelEditTag"
    >
      <feather-icon icon="XIcon" stroke="#B9B9C3" class="custom__icon--size" />
    </div>
  </div>
</template>

<script>
import { BBadge } from "bootstrap-vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"
export default {
  name: "MoleculeEditTag",
  components: {
    AtomMultiSelect,
    BBadge,
  },
  props: {
    tagList: {
      type: [Array, null],
      required: false,
      default: null,
    },
    optionTagList: {
      type: Array,
      required: true,
    },
    isEditable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      bufferTagList: [],
      selectTaglist: null,
      isTagEditMode: false,
    }
  },
  watch: {
    tagList: {
      deep: true,
      handler() {
        this.isTagEditMode = false
        this.bufferTagList = this.tagList
      },
    },
  },
  mounted() {
    this.bufferTagList = this.tagList
  },
  methods: {
    editTagToggle() {
      this.isTagEditMode = !this.isTagEditMode
    },
    confirmEditTag() {
      this.isTagEditMode = !this.isTagEditMode
      this.$emit("updateCurrentEquipmentTagList", this.bufferTagList)
    },
    cancelEditTag() {
      this.isTagEditMode = !this.isTagEditMode
      this.bufferTagList = this.tagList
    },
  },
}
</script>

<style lang="scss" scoped>
.molecule_container {
  display: flex;
}
.custom__margin-top {
  margin-top: 8px;
}
.tag-badge--space {
  margin-top: 6px;
  margin-left: 15px;
  line-height: 1.8;
}
.tag--space {
  margin-left: 5px;
}

.tag-badge--space.badge--no-margin-left {
  margin-left: 0;
  margin-top: 0;
}
.button__edit-tag {
  &:hover {
    cursor: pointer;
  }
}
.multi-select--space {
  width: 100%;
  margin-left: 15px;
}
.select-tag {
  display: block;
}
.custom__icon--size {
  height: 24px;
  width: 24px;
}
.custom__icon {
  margin-left: 13px;
  &:hover {
    cursor: pointer;
  }
}
// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
}
// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
